import Typography from '@mui/material/Typography';
import { FC, useEffect } from 'react';
import React from 'react';

import { theme } from '../../services/theme';
import { Dialog } from '../Dialog';

interface Props {
  isOpen: boolean;
  message?: React.ReactNode;
  onClose: () => void;
  title: string;
  type?: 'error' | 'info' | 'success';
}

const titleColorsMap = {
  error: '#D7335C',
  info: '#356482',
  success: '#50C9CE',
};

export const Alert: FC<Props> = ({
  isOpen,
  message,
  onClose,
  title,
  type = 'info',
}) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        padding: '30px 100px',
        [theme.breakpoints.down('sm')]: {
          padding: '20px 30px',
        },
        [theme.breakpoints.down('mobile')]: {
          padding: '20px 10px',
        },
      }}
    >
      <Typography
        fontWeight="regular"
        sx={{
          color: titleColorsMap[type],
          fontSize: '24px',
          lineHeight: '34px',
          marginBottom: '20px',
          textAlign: 'center',
          [theme.breakpoints.down('sm')]: {
            fontSize: '18px',
            lineHeight: '20px',
          },
          [theme.breakpoints.down('mobile')]: {
            fontSize: '16px',
            lineHeight: '18px',
          },
        }}
      >
        {title}
      </Typography>
      {message && (
        <Typography
          fontWeight="regular"
          sx={{
            color: 'rgba(53, 100, 130, 0.7)',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '22px',
            marginBottom: '12px',
            textAlign: 'center',
            [theme.breakpoints.down('sm')]: {
              fontSize: '14px',
              lineHeight: '16px',
            },
            [theme.breakpoints.down('mobile')]: {
              fontSize: '12px',
              lineHeight: '14px',
            },
          }}
        >
          {message}
        </Typography>
      )}
    </Dialog>
  );
};
